import { useContext, useState } from 'react';
import { SiteContentContext } from '../context/SiteContentContext';
import QuestionModal from '../components/QuestionModal';
import { useSeo } from '../hooks/useSeo';
import '../styles/fleet_page.css';

const PackingPage = ({ isPreview = false }) => { // eslint-disable-line no-unused-vars
  useSeo({
    title: 'Что взять с собой',
    description: 'Список вещей для парусного путешествия и обучения яхтингу — что взять на борт, чтобы ничего не забыть.',
  });
  const { content } = useContext(SiteContentContext);
  const [isQuestionOpen, setIsQuestionOpen] = useState(false);
  const packingItems = content.packingItems || [];

  return (
    <main>
      <section className={`fleet-page-hero${content.packingHeroImage ? " has-cover" : ""}`} style={content.packingHeroImage ? { backgroundImage: `url(${content.packingHeroImage})` } : {}}>
        <h1>Что взять с собой</h1>
        <p>Чек-лист для комфортного яхтенного похода</p>
      </section>
      <div className="fleet-page">

      {packingItems.length === 0 ? (
        <div className="fleet-page-empty">
          <p>Список вещей пока не заполнен. Добавьте категории в <a href="/admin">админке</a> во вкладке ✏️ Контент → Что взять.</p>
        </div>
      ) : (
        <div className="packing-grid">
          {packingItems.map(section => (
            <div key={section.id} className="packing-section">
              <h2>{section.category}</h2>
              <ul>
                {(section.items || []).map((item, i) => (
                  <li key={i}>
                    <span className="packing-check">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
      </div>
      <section className="cta-section">
        <h2>Остались вопросы?</h2>
        <p>Напишите нам — ответим в течение дня.</p>
        <button className="cta-button" onClick={() => setIsQuestionOpen(true)}>Задать вопрос</button>
      </section>
      <QuestionModal isOpen={isQuestionOpen} onClose={() => setIsQuestionOpen(false)} pageTitle="Что взять с собой" />
    </main>
  );
};

export default PackingPage;
